/** User-selected preview preferences only; no inferred biometrics or persistence. */
export interface SizingSelection { pd: number; manual: boolean; face: number; width: number }
let current: SizingSelection = { pd: 60, manual: false, face: 60, width: 145 };
export function readSizingSession(): SizingSelection { return { ...current }; }
export function rememberSizingSession(selection: SizingSelection): void { current = { ...selection }; }
